<template>
	<el-tabs v-model="activeName" @tab-click="handleClick">
		<el-tab-pane label="线下汇款" name="1">
			<el-form label-position="right" label-width="100px">
				<el-form-item label="收款机构:">
					<el-col :span="12">
						<span>{{add_data.rp_mechanism}}</span>
					</el-col>
				</el-form-item>
				<el-form-item label="收款人:">
					<el-col :span="12">
						<span>{{add_data.rp_user}}</span>
					</el-col>
				</el-form-item>
				<el-form-item label="收款账号:">
					<el-col :span="12">
						<span>{{add_data.rp_account}}</span>
					</el-col>
				</el-form-item>
				<el-form-item label="充值金额:">
					<el-col :span="12">
						<el-input-number v-model="add_data.money" controls-position="right" :precision="2" :step="100"
							:min="0.00">
						</el-input-number>
					</el-col>
				</el-form-item>
				<el-form-item label="转账截图:">
					<el-col :span="12">
						<Img @imgList="imgsImg" :img_num="1" :img_edit="add_data.img"></Img>
					</el-col>
				</el-form-item>
				<el-row>
					<el-col :span="4" :offset="2">
						<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="add">立即充值</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-card class="box-card" style="margin-top: 20px;font-size: 14px;">
				{{add_data.desc}}
			</el-card>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import {
		getSysSet,
		recharge
	} from '@/api/jd_task'
	import Qs from 'qs'
	import Img from '@/components/Jd/img.vue' // 上传图片组件
	export default {
		components: {
			Img
		},
		data() {
			return {
				activeName: '1',
				add_data: {
					'rp_mechanism': '',
					'rp_user': '',
					'rp_account': '',
					'desc': '',
					'money': 0,
					'img': []
				}
			};
		},
		created() {
			this.getSysSet();
		},
		methods: {
			getSysSet(type) {
				getSysSet(Qs.stringify({
					'type': 'xxfk'
				})).then(response => {
					let res = response.result;
					this.add_data.rp_mechanism = res.rp_mechanism;
					this.add_data.rp_user = res.rp_user;
					this.add_data.rp_account = res.rp_account;
					this.add_data.desc = res.desc;
				})
			},
			handleClick(tab, event) {
			},
			imgsImg(e) { // 用户图片调用组件时候的回调
				this.add_data.img = e;
			},
			add() {
				this.$store.commit('setAjaxLoading', true);
				recharge(Qs.stringify(this.add_data)).then(response => {
					this.$message({
						showClose: true,
						message: '提交成功，请等待审核',
						type: 'success'
					});
					location.reload();
				})
			}
		}
	};
</script>

<style>
</style>
